import Vue from 'vue'
import Router from 'vue-router'
// import i18n from './i18n'
import store from '@/store'
import {
  pushPageContext,
  pushUserContext,
  pushScreenOpenedEvent
} from '@/util/gtm'
import {eraseCookie, getCookie, setCookie} from "./util/cookies";
// import {defaultLanguage, supportedLanguages} from '@/config'

Vue.use(Router)

const createHistory = (...values) => {
  window.history.replaceState(
    {},
    null,
    store.getters['app/isMobile']
      ? process.env.BASE_URL + 'account'
      : process.env.BASE_URL + 'home'
  )
  for (var i = 0; i < values.length; i++) {
    window.history.pushState({}, null, process.env.BASE_URL + values[i])
  }
}

const originalPush = Router.prototype.push
Router.prototype.push = function push (location, onResolve, onReject) {
  if (onResolve || onReject) { return originalPush.call(this, location, onResolve, onReject) }
  return originalPush.call(this, location).catch((err) => err)
}
const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'intro',
      meta: {
        auth: false
      },
      component: () =>
        import(/* webpackChunkName: "Intro" */ '@/views/Intro.vue')
    },
    {
      path: '/login/callback',
      name: 'login-callback',
      meta: {
        auth: false
      }
    },
    {
      path: '/join',
      name: 'join',
      meta: {
        auth: false
      },
      component: () =>
        import(/* webpackChunkName: "Join" */ '@/views/Join.vue')
    },
    {
      path: '/redirect/:id',
      name: 'redirect',
      component: () =>
        import(/* webpackChunkName: "Redirect" */ '@/views/Redirect.vue')
    },
    {
      path: '/banned',
      name: 'banned',
      meta: {
        auth: false
      },
      component: () =>
        import(/* webpackChunkName: "Inactive" */ '@/views/Inactive.vue')
    },
    {
      path: '/register',
      name: 'register',
      meta: {
        auth: false
      },
      component: () =>
        import(/* webpackChunkName: "Register" */ '@/views/Register.vue')
    },
    {
      path: '/agreement',
      name: 'agreement',
      component: () =>
        import(/* webpackChunkName: "Agreement" */ '@/views/Agreement.vue')
    },
    {
      path: '/confirm-payment-method',
      name: 'confirm-payment-method',

      component: () =>
        import(
          /* webpackChunkName: "ConfirmPaymentMethod" */ '@/views/ConfirmPaymentMethod.vue'
        )
    },
    {
      meta: {
        auth: true
      },
      path: '/home',
      name: 'home',
      component: () =>
        import(
          /* webpackChunkName: "Dashboard" */ '@/modules/dashboard/Dashboard.vue'
        )
    },
    {
      path: '/account',
      meta: {
        auth: true
      },
      name: 'account',
      component: () =>
        import(/* webpackChunkName: "YouPage" */ '@/views/YouPage.vue'),
      beforeEnter: (to, from, next) => {
        if (from.name === null) {
          createHistory('account')
        }
        next()
      }
    },
    {
      path: '/personal-info',
      component: () =>
        import(
          /* webpackChunkName: "PersonalInfo" */ '@/modules/user/PersonalInfo.vue'
        ),
      children: [
        {
          path: '',
          name: 'personal-info',
          meta: {
            auth: true
          },
          component: () =>
            import(
              /* webpackChunkName: "PersonalInfoView" */ '@/modules/user/PersonalInfoView.vue'
            ),
          beforeEnter: (to, from, next) => {
            if (from.name === null) {
              createHistory('personal-info')
            }
            next()
          }
        },
        {
          path: 'edit',
          meta: {
            auth: true
          },
          name: 'personal-info-edit',
          component: () =>
            import(
              /* webpackChunkName: "PersonalInfoEdit" */ '@/modules/user/PersonalInfoEdit.vue'
            ),
          beforeEnter: (to, from, next) => {
            if (from.name === null) {
              createHistory('personal-info', 'personal-info/edit')
            }
            next()
          }
        }
      ]
    },
    {
      path: '/payment-method',
      component: () =>
        import(
          /* webpackChunkName: "PaymentMethods" */ '@/modules/user/PaymentMethods.vue'
        ),
      children: [
        {
          path: '',
          name: 'payment-method',
          meta: {
            auth: true
          },
          component: () =>
            import(
              /* webpackChunkName: "PaymentMethodsList" */ '@/modules/user/PaymentMethodsList.vue'
            ),
          beforeEnter: (to, from, next) => {
            if (from.name === null) {
              createHistory('payment-method')
            }
            next()
          }
        },
        {
          path: ':id/edit',
          meta: {
            auth: true
          },
          name: 'payment-method-edit',
          component: () =>
            import(
              /* webpackChunkName: "PaymentMethodsEdit" */ '@/modules/user/PaymentMethodsEdit.vue'
            ),
          beforeEnter: (to, from, next) => {
            if (from.name === null) {
              createHistory('payment-method', 'payment-method-edit')
            }
            next()
          }
        },
        {
          path: 'bank_transfer',
          name: 'bank-account-add',
          meta: {
            auth: false
          },
          component: () =>
            import(
              /* webpackChunkName: "PaymentMethodsBankAccountAdd" */ '@/modules/user/PaymentMethodsBankAccountAdd.vue'
            ),
          beforeEnter: (to, from, next) => {
            if (from.name === null) {
              createHistory('payment-method', 'bank-account-add')
            }
            next()
          }
        },
        {
          path: 'mobile_money',
          meta: {
            auth: false
          },
          name: 'mobile-money-account-add',
          component: () =>
            import(
              /* webpackChunkName: "PaymentMethodsMobileMoneyAdd" */ '@/modules/user/PaymentMethodsMobileMoneyAdd.vue'
            ),
          beforeEnter: (to, from, next) => {
            if (from.name === null) {
              createHistory('payment-method', 'mobile-money-account-add')
            }
            next()
          }
        }
        // {
        //   path: 'mtn',
        //   name: 'mtn-account-add',
        //   component: () => import(/* webpackChunkName: "PaymentMethodsMTNAdd" */ '@/modules/user/PaymentMethodsMTNAdd.vue'),
        //   beforeEnter: (to, from, next) => {
        //     // if (from.name === null) {
        //     //   createHistory('payment-method', 'payment-method-edit')
        //     // }
        //     next()
        //   }
        // }
      ]
    },
    {
      path: '/level',
      meta: {
        auth: true
      },
      component: () =>
        import(/* webpackChunkName: "Level" */ '@/modules/level/Level.vue'),
      children: [
        {
          path: '',
          name: 'level-info',
          meta: {
            auth: true
          },
          component: () =>
            import(
              /* webpackChunkName: "LevelInfo" */ '@/modules/level/LevelInfo.vue'
            ),
          beforeEnter: (to, from, next) => {
            if (from.name === null) {
              createHistory('level')
            }
            next()
          }
        },
        {
          path: 'advantages',
          name: 'level-advantages',
          meta: {
            auth: true
          },
          component: () =>
            import(
              /* webpackChunkName: "LevelAdvantages" */ '@/modules/level/LevelAdvantages.vue'
            ),
          beforeEnter: (to, from, next) => {
            if (from.name === null) {
              next({ name: 'level-info', replace: true })
            }
            next()
          }
        },
        {
          path: 'next-level-advantages',
          name: 'level-next-advantages',
          meta: {
            auth: true
          },
          component: () =>
            import(
              /* webpackChunkName: "LevelNextAdvantages" */ '@/modules/level/LevelNextAdvantages.vue'
            ),
          beforeEnter: (to, from, next) => {
            if (from.name === null) {
              next({ name: 'level-info', replace: true })
            }
            next()
          }
        }
      ]
    },
    {
      path: '/sales',
      component: () =>
        import(/* webpackChunkName: "Sales" */ '@/modules/sales/Sales.vue'),
      children: [
        {
          path: '',
          name: 'sales',
          meta: {
            auth: true
          },
          component: () =>
            import(
              /* webpackChunkName: "Sales" */ '@/modules/sales/SalesBalance.vue'
            ),
          beforeEnter: (to, from, next) => {
            if (from.name === null) {
              createHistory('sales')
            }
            next()
          }
        },
        {
          path: 'status/:status',
          meta: {
            auth: true
          },
          name: 'sales-status',
          component: () =>
            import(
              /* webpackChunkName: "Sales" */ '@/modules/sales/SalesStatus.vue'
            ),
          beforeEnter: (to, from, next) => {
            if (from.name === null) {
              createHistory('sales', 'sales/status/' + to.params.status)
            }
            next()
          }
        },
        {
          path: 'category/:category',
          meta: {
            auth: true
          },
          name: 'sales-category',
          component: () =>
            import(
              /* webpackChunkName: "Sales" */ '@/modules/sales/SalesCategory.vue'
            ),
          beforeEnter: (to, from, next) => {
            if (from.name === null) {
              createHistory('sales', 'sales/category/' + to.params.category)
            }
            next()
          }
        },
        {
          path: 'status/:status/category/:category',
          meta: {
            auth: true
          },
          name: 'sales-status-category',
          component: () =>
            import(
              /* webpackChunkName: "Sales" */ '@/modules/sales/SalesStatusCategory.vue'
            ),
          beforeEnter: (to, from, next) => {
            if (from.name === null) {
              createHistory(
                'sales',
                'sales/status/' + to.params.status,
                'sales/status/' +
                  to.params.status +
                  '/category/' +
                  to.params.category
              )
            }
            next()
          }
        },
        {
          path: 'category/:category/status/:status',
          meta: {
            auth: true
          },
          name: 'sales-category-status',
          component: () =>
            import(
              /* webpackChunkName: "Sales" */ '@/modules/sales/SalesStatusCategory.vue'
            ),
          beforeEnter: (to, from, next) => {
            if (from.name === null) {
              createHistory(
                'sales',
                'sales/category/' + to.params.category,
                'sales/category/' +
                  to.params.category +
                  '/status/' +
                  to.params.status
              )
            }
            next()
          }
        }
      ]
    },
    {
      path: '/orders',
      meta: {
        auth: true
      },
      component: () =>
        import(/* webpackChunkName: "Orders" */ '@/modules/orders/Orders.vue'),
      children: [
        {
          path: '',
          name: 'orders-list',
          meta: {
            auth: true
          },
          component: () =>
            import(
              /* webpackChunkName: "OrdersList" */ '@/modules/orders/OrdersList.vue'
            ),
          beforeEnter: (to, from, next) => {
            if (from.name === null) {
              createHistory('orders')
            }

            // prevent loading orders when comming back from the Orders Details Page
            if (
              from.name !== 'orders-details' &&
              from.name !== 'orders-list-filters'
            ) {
              // eslint-disable-next-line no-underscore-dangle
              if ('orders' in store._modules.root._children) {
                store.dispatch('orders/refreshOrders', true)
              }
            }
            next()
          }
        },
        {
          path: 'filter',
          meta: {
            auth: true
          },
          name: 'orders-list-filters',
          component: () =>
            import(
              /* webpackChunkName: "OrdersListFilters" */ '@/modules/orders/OrdersListFilters.vue'
            ),
          beforeEnter: (to, from, next) => {
            if (from.name === null) {
              createHistory('orders', 'orders/filters')
            }
            next()
          },
          props: true
        },
        {
          path: ':id/orderType/:orderType',
          props: true,
          meta: {
            auth: true
          },
          name: 'orders-details',
          component: () =>
            import(
              /* webpackChunkName: "OrdersDetails" */ '@/modules/orders/OrdersDetails.vue'
            ),
          beforeEnter: (to, from, next) => {
            if (from.name === null) {
              createHistory('orders', 'orders/' + to.params.id)
            }
            next()
          }
        },
        {
          path: ':id/item/:itemId',
          meta: {
            auth: true
          },
          name: 'orders-item-details',
          component: () =>
            import(
              /* webpackChunkName: "OrdersItemDetailsPage" */ '@/modules/orders/OrdersItemDetailsPage.vue'
            ),
          beforeEnter: (to, from, next) => {
            if (from.name === null) {
              next({ name: 'orders-details', params: { id: to.params.id, orderType: from.params.orderType } })
            }
            next()
          }
        }
      ]
    },
    {
      path: '/bonuses',
      meta: {
        auth: true
      },
      component: () =>
        import(
          /* webpackChunkName: "Bonuses" */ '@/modules/bonuses/Bonuses.vue'
        ),
      children: [
        {
          path: '',
          name: 'bonuses-list',
          meta: {
            auth: true
          },
          component: () =>
            import(
              /* webpackChunkName: "BonusesList" */ '@/modules/bonuses/BonusBalance.vue'
            ),
          beforeEnter: (to, from, next) => {
            if (from.name === null) {
              createHistory('bonues')
            }
            next()
          }
        },
        {
          path: 'details/:id',
          meta: {
            auth: true
          },
          name: 'bonuses-item-details-page',
          component: () =>
            import(
              /* webpackChunkName: "BonusesItemDetailsPage" */ '@/modules/bonuses/BonusesItemDetailsPage.vue'
            ),
          beforeEnter: (to, from, next) => {
            if (from.name === null) {
              // next({ name: 'bonuses-item-details-page', params: { id: to.params.id } })
            }
            next()
          }
        }
      ]
    },
    {
      path: '/contributors',
      name: 'core',
      component: () =>
        import(/* webpackChunkName: "Core" */ '@/views/Core.vue')
    },
    {
      path: '/team-members',
      meta: {
        auth: true
      },
      component: () =>
        import(
          /* webpackChunkName: "TeamMembers" */ '@/modules/team/TeamMembers.vue'
        ),
      children: [
        {
          path: '',
          name: 'team-members-list',
          meta: {
            auth: true
          },
          component: () =>
            import(
              /* webpackChunkName: "TeamMembersList" */ '@/modules/team/TeamMembersList.vue'
            ),
          beforeEnter: (to, from, next) => {
            if (from.name === null) {
              createHistory('team-members')
            }
            next()
          }
        },
        {
          path: ':id',
          name: 'team-members-info',
          meta: {
            auth: true
          },
          component: () =>
            import(
              /* webpackChunkName: "TeamMembersInfo" */ '@/modules/team/TeamMembersInfo.vue'
            ),
          beforeEnter: (to, from, next) => {
            if (from.name === null) {
              createHistory('team-members', 'team-members/' + to.params.id)
            }
            next()
          }
        }
      ]
    },
    {
      path: '/team-leader',
      meta: {
        auth: true
      },
      name: 'team-leader',
      component: () =>
        import(
          /* webpackChunkName: "TeamLeader" */ '@/modules/team/TeamLeader.vue'
        ),
      beforeEnter: (to, from, next) => {
        if (from.name === null) {
          createHistory('team-leader')
        }
        next()
      }
    },
    {
      path: '/success-rate',
      meta: {
        auth: true
      },
      component: () =>
        import(
          /* webpackChunkName: "SuccessRate" */ '@/modules/success-rate/SuccessRate.vue'
        ),
      children: [
        {
          path: '',
          name: 'sr-configs-list',
          meta: {
            auth: true
          },
          component: () =>
            import(
              /* webpackChunkName: "SrConfigsList" */ '@/modules/success-rate/SrConfigsList.vue'
            ),
          beforeEnter: (to, from, next) => {
            if (from.name === null) {
              createHistory('success-rate', 'success-rate/srconfigs')
            }
            next()
          }
        }
      ]
    },
    {
      path: '/notifications',
      meta: {
        auth: true
      },
      component: () =>
        import(
          /* webpackChunkName: "Notifications" */ '@/modules/notifications/Notifications.vue'
        ),
      children: [
        {
          path: '',
          name: 'notifications-list',
          meta: {
            auth: true
          },
          component: () =>
            import(
              /* webpackChunkName: "NotificationsList" */ '@/modules/notifications/NotificationsList.vue'
            ),
          beforeEnter: (to, from, next) => {
            if (from.name === null) {
              createHistory('notifications')
            }
            next()
          }
        }
      ]
    },
    {
      path: '/commissions',
      meta: {
        auth: true
      },
      component: () =>
        import(
          /* webpackChunkName: "Commissions" */ '@/modules/commissions/Commissions.vue'
        ),
      children: [
        {
          path: '',
          name: 'commissions',
          meta: {
            auth: true
          },
          component: () =>
            import(
              /* webpackChunkName: "CommissionsBalance" */ '@/modules/commissions/CommissionsBalance.vue'
            ),
          beforeEnter: (to, from, next) => {
            if (from.name === null) {
              createHistory('commissions')
            }
            next()
          }
        },
        {
          path: 'services',
          meta: {
            auth: true
          },
          name: 'commission-services',
          component: () =>
            import(
              /* webpackChunkName: "CommissionsServices" */ '@/modules/commissions/CommissionsServices.vue'
            ),
          beforeEnter: (to, from, next) => {
            if (from.name === null) {
              createHistory('commissions', 'commissions/services')
            }
            next()
          }
        },
        {
          path: 'confirmed',
          meta: {
            auth: true
          },
          name: 'commissions-confirmed',
          component: () =>
            import(
              /* webpackChunkName: "CommissionsConfirmed" */ '@/modules/commissions/CommissionsConfirmed.vue'
            ),
          beforeEnter: (to, from, next) => {
            if (from.name === null) {
              createHistory('commissions', 'commissions/confirmed')
            }
            next()
          }
        },
        {
          path: 'group-by-sale',
          meta: {
            auth: true
          },
          name: 'commissions-type',
          component: () =>
            import(
              /* webpackChunkName: "CommissionsConfirmedType" */ '@/modules/commissions/CommissionsConfirmedType.vue'
            ),
          beforeEnter: (to, from, next) => {
            if (from.name === null) {
              createHistory('commissions', 'commissions/' + to.params.type)
            }
            next()
          }
        },
        {
          path: ':category',
          meta: {
            auth: true
          },
          name: 'commissions-confirmed-type-category',
          component: () =>
            import(
              /* webpackChunkName: "CommissionsConfirmedTypeCategory" */ '@/modules/commissions/CommissionsConfirmedTypeCategory.vue'
            ),
          beforeEnter: (to, from, next) => {
            if (from.name === null) {
              createHistory('commissions', 'commissions/' + to.params.category)
            }
            next()
          }
        },
        {
          path: 'pending',
          meta: {
            auth: true
          },
          name: 'commissions-pending',
          component: () =>
            import(
              /* webpackChunkName: "CommissionsPending" */ '@/modules/commissions/CommissionsPending.vue'
            ),
          beforeEnter: (to, from, next) => {
            if (from.name === null) {
              createHistory('commissions', 'commissions/pending')
            }
            next()
          }
        },
        {
          path: 'pending/:type',
          meta: {
            auth: true
          },
          name: 'commissions-pending-type',
          component: () =>
            import(
              /* webpackChunkName: "CommissionsPendingType" */ '@/modules/commissions/CommissionsPendingType.vue'
            ),
          beforeEnter: (to, from, next) => {
            if (from.name === null) {
              createHistory(
                'commissions',
                'commissions/pending',
                'commissions/pending/' + to.params.type
              )
            }
            next()
          }
        },
        {
          path: 'pending/:type/category/:category',
          meta: {
            auth: true
          },
          name: 'commissions-pending-type-category',
          component: () =>
            import(
              /* webpackChunkName: "CommissionsPendingTypeCategory" */ '@/modules/commissions/CommissionsPendingTypeCategory.vue'
            ),
          beforeEnter: (to, from, next) => {
            if (from.name === null) {
              createHistory(
                'commissions',
                'commissions/pending',
                'commissions/pending/' + to.params.type,
                'commissions/pending/' +
                  to.params.type +
                  '/category/' +
                  to.params.category
              )
            }
            next()
          }
        },
        {
          path: 'pending/:type/status/:status',
          name: 'commissions-pending-type-status',
          meta: {
            auth: true
          },
          component: () =>
            import(
              /* webpackChunkName: "CommissionsPendingTypeStatus" */ '@/modules/commissions/CommissionsPendingTypeStatus.vue'
            ),
          beforeEnter: (to, from, next) => {
            if (from.name === null) {
              createHistory(
                'commissions',
                'commissions/pending',
                'commissions/pending/' + to.params.type,
                'commissions/pending/' +
                  to.params.type +
                  '/status/' +
                  to.params.status
              )
            }
            next()
          }
        },
        {
          path: 'pending/:type/status/:status/category/:category',
          meta: {
            auth: true
          },
          name: 'commissions-pending-type-status-category',
          component: () =>
            import(
              /* webpackChunkName: "CommissionsPendingTypeStatusCategory" */ '@/modules/commissions/CommissionsPendingTypeStatusCategory.vue'
            ),
          beforeEnter: (to, from, next) => {
            if (from.name === null) {
              createHistory(
                'commissions',
                'commissions/pending',
                'commissions/pending/' + to.params.type,
                'commissions/pending/' +
                  to.params.type +
                  '/status/' +
                  to.params.status,
                'commissions/pending/' +
                  to.params.type +
                  '/status/' +
                  to.params.status +
                  '/category/' +
                  to.params.category
              )
            }
            next()
          }
        },
        {
          path: 'pending/:type/category/:category/status/:status',
          meta: {
            auth: true
          },
          name: 'commissions-pending-type-category-status',
          component: () =>
            import(
              /* webpackChunkName: "CommissionsPendingTypeStatusCategory" */ '@/modules/commissions/CommissionsPendingTypeStatusCategory.vue'
            ),
          beforeEnter: (to, from, next) => {
            if (from.name === null) {
              createHistory(
                'commissions',
                'commissions/pending',
                'commissions/pending/' + to.params.type,
                'commissions/pending/' +
                  to.params.type +
                  '/category/' +
                  to.params.category,
                'commissions/pending/' +
                  to.params.type +
                  '/category/' +
                  to.params.category +
                  '/status/' +
                  to.params.status
              )
            }
            next()
          }
        }
      ]
    },
    {
      path: '/:id',
      meta: {
        auth: true
      },
      name: 'cms',
      component: () =>
        import(/* webpackChunkName: "CMSPage" */ '@/views/CMSPage.vue'),
      beforeEnter: (to, from, next) => {
        if (from.name === null) {
          store
            .dispatch('app/getStaticBlock', to.params.id)
            .then((response) => {
              if (response.success) {
                window.history.replaceState(
                  {},
                  null,
                  process.env.BASE_URL + 'home'
                )
                window.history.pushState(
                  {},
                  null,
                  process.env.BASE_URL + to.params.id
                )
                next()
              } else {
                next('/')
              }
            })
        } else {
          next()
        }
      }
    },
    {
      path: '*',
      redirect: '/',
      meta: {
        auth: false
      }
    }
  ],
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})

// const loadedLanguages = [defaultLanguage]

// const setI18nLanguage = (lang) => {
//   i18n.locale = lang
//   // axios.defaults.headers.common['Accept-Language'] = lang
//   document.querySelector('html').setAttribute('lang', lang)
//   return lang
// }

// const loadLanguageAsync = (lang) => {
//   if (i18n.locale !== lang) {
//     if (!loadedLanguages.includes(lang)) {
//       return import(/* webpackChunkName: "lang-[request]" */ `@/locales/${lang}`).then(msgs => {
//         store.dispatch('app/changeLanguage', lang)
//         i18n.setLocaleMessage(lang, msgs)
//         loadedLanguages.push(lang)
//         return setI18nLanguage(lang)
//       })
//     }
//     return Promise.resolve(setI18nLanguage(lang))
//   }
//   return Promise.resolve(lang)
// }

const hasRoutePermission = (path) => {
  if (
    path.startsWith('/team-members') &&
    !store.getters['app/featureToggles'].teamMembers
  ) { return false }
  if (
    path.startsWith('/team-leader') &&
    !store.getters['app/featureToggles'].teamLeader
  ) { return false }
  if (path.startsWith('/level') && !store.getters['app/featureToggles'].levels) { return false }
  if (path.startsWith('/orders') && !store.getters['app/featureToggles'].orders) { return false }
  if (
    path.startsWith('/notifications') &&
    !store.getters['app/featureToggles'].notifications
  ) { return false }
  if (path.startsWith('/sales') && !store.getters['app/featureToggles'].sales) { return false }
  if (
    path.startsWith('/success-rate') &&
    !store.getters['app/featureToggles'].success_rate
  ) { return false }
  if (
    path.startsWith('/personal-info') &&
    !store.getters['app/featureToggles'].personalInfo
  ) { return false }
  if (
    path.startsWith('/payment-method') &&
    !store.getters['app/featureToggles'].paymentMethods
  ) { return false }
  if (
    path.startsWith('/commissions') &&
    !store.getters['app/featureToggles'].commissions
  ) { return false }
  if (path.startsWith('/bonuses') && !store.getters['app/featureToggles'].bonus) { return false }
  return true
}

router.beforeEach((to, from, next) => {
  if (to.name === 'join' && to.query.referral) {
    setCookie('referralCode', to.query.referral, 7)
  }


  const email = to.query.impersonate ? to.query.impersonate : ''
  if (email) {
     store.commit('user/IS_IMPERSONATE', true)
     setCookie('impersonate', email, 1)
  }
  store.dispatch('app/loadingPageStart')

  const code = to.query.code
  const oauthState = to.query.state
  store.dispatch('user/login', {code, oauthState, email}).then((response) => {
    eraseCookie("auth-state")

    const isJForce = response.isJForce
    const isInactive = response.isInactive
    const isPaymentMethodMandatory = response.isPaymentMethodMandatory
    const paymentMethodNeedConfirmation = response.paymentMethodNeedConfirmation
    const acceptedAgreement = response.acceptedAgreement
    const jforceId = response.jforceId ? response.jforceId : 'not logged'
    const jumiaId = response.jumiaId ? response.jumiaId : 'not logged'
    const updatedJforceAgreement = response.updatedJforceAgreement
    const isImpersonate = !!email

    const where = whereToGo(
        to.name,
        response.success,
        isJForce,
        isInactive,
        isPaymentMethodMandatory,
        paymentMethodNeedConfirmation,
        acceptedAgreement,
        isImpersonate
    )

    if (where === to.name || where === 'no_redirect') {
      // Redirect to the homepage if trying to access to a route without permission
      if (!hasRoutePermission(to.path)) next({name: 'home', replace: true})

      // Analytics - Track User when accessing the application
      if (from.name === null) {
        pushUserContext(jforceId, jumiaId)
      }
      if (
          to.meta.auth &&
          response.success &&
          updatedJforceAgreement !== undefined &&
          !updatedJforceAgreement &&
          !isImpersonate
      ) {
        window.dispatchEvent(
            new CustomEvent('agreement-updated', {
              bubbles: true,
              detail: {val: true, persistent: true, source: 'route'}
            })
        )
      }
      next()
    } else {
      // if redirecting to the actual page finish the loading
      if (where === from.name) {
        store.dispatch('app/loadingPageEnd')
      }
      next({name: where, replace: true})
    }
  })
})

const whereToGo = (
  to,
  isAuth,
  isJForce,
  isInactive,
  isPaymentMethodMandatory,
  paymentMethodNeedConfirmation
) => {
  if (to === 'core') return 'no_redirect'

  if (to !== 'intro' && to !== 'login-callback') {
    // 1 hour
    const time = 1 / 24

    setCookie('redirect-url', to, time)
  }

  if (!isAuth) {
    window.dispatchEvent(new CustomEvent('cookie-not-found', {bubbles: true}))
    return 'intro'
  } 

  if (isInactive) return 'banned'

  if (!isJForce && to === 'register') return 'no_redirect'
  if (!isJForce) return 'join'
  if (!store.getters['user/acceptedAgreement']) return 'register'
  if (isPaymentMethodMandatory && paymentMethodNeedConfirmation && !store.getters['user/isImpersonate']) { return 'confirm-payment-method' }

  if (
    isJForce &&
    !isInactive &&
    !paymentMethodNeedConfirmation &&
    [
      'banned',
      'join',
      'intro',
      'register',
      'agreement',
      'confirm-payment-method',
    ].includes(to)
  ) { return 'home' }

  if (to === 'login-callback') {
    const cookie = getCookie("redirect-url")
    if (cookie) {
      return cookie
    }

    return 'home'
  }

  return 'no_redirect'
}

router.afterEach((to) => {
  store.dispatch('app/loadingPageEnd')
  // Analytics - Track Page views
  Vue.nextTick(() => {
    if (to.name !== 'core') {
      pushPageContext(to.name, to.path, store.getters['app/pageLayoutType'])
      pushScreenOpenedEvent(to.name, to.path)
    }
  })
})

export default router
